module.exports = __webpack_public_path__ + "static/client2-2d37ae54ee8f0f1d5abab0ac3033662b.png";